import { Component, Input, OnInit } from '@angular/core';
import { ConsoleLoggerService } from '../../../../core/services/console-logger.service';
import { StorageService } from '../../../../shared/services/storage.service';
import { FirebaseError } from '@angular/fire/app/firebase';
import { AuthService } from '../../../../core/services/auth.service';
import { User } from '@angular/fire/auth';
import { AppComponent } from '../../../../app.component';

@Component({
  selector: 'anon-photo-upload',
  templateUrl: './photo-upload.component.html',
  styleUrls: ['./photo-upload.component.scss']
})
export class PhotoUploadComponent implements OnInit {
  @Input() public user?: User;
  public photo?: string;
  public validExtensions = [];
  public file?: File;
  public editing: boolean = false;
  public loading: boolean = false;

  constructor(
    private cLog: ConsoleLoggerService,
    private storage: StorageService,
    private auth: AuthService
  ) {}

  ngOnInit() {
    this.photo = this.user?.photoURL!;
  }

  public async onFilesSelect(event: any) {
    this.file = event.target.files[0];
    if (this.file) {
      this.loading = true;
      await this.storage.upload(`users/${this.user?.uid}/${this.file.name}`, this.file)
        .then(async (res) => {
          await this.storage.getURL(res.ref)
            .then(async (url) => {
              await this.auth.updateUser({photoURL: url})
                .then((res) => {
                  if (res.ok) this.notifyReload(res.message);
                })
                .catch((error: Error) => this.cLog.error(`error updating profile: ${error.message}`, error));
              this.photo = url;
            })
            .catch((error: FirebaseError) => this.cLog.error(`error getting uploaded files url: ${error.message}`, error))
        })
        .catch((error: FirebaseError) => this.cLog.error(`error uploading photo: ${error.message}`, error))
    }
    this.editing = false;
    this.loading = false;
  }

  async clear() {
    this.loading = true;
    await this.auth.updateUser({photoURL: null})
      .then((res) => {
        if (res.ok) this.notifyReload(res.message);
      })
      .catch((error: Error) => this.cLog.error(`error updating profile: ${error.message}`, error));
    this.photo = undefined;
  }

  notifyReload(msg: string) {
    return this.cLog.openSnackBar(
      msg + '; Reload page for changes to take affect.',
      'Reload',
      {duration: 0}
    ).onAction().subscribe(() => {if (AppComponent.isBrowser) window.location.reload()});
  }
}
